/* jshint node:true */
'use strict';

/*
    Action:     Mimic the jquery UI date picker
    Original:   ---
    Orginator:  ben.hobden@espn.com
    Returns:    The JavaScript date iobject in the callback function
*/

var React                   = require('react');
var classNames              = require('classnames');
var DateFormatMixin         = require('../../mixins/DateFormatMixin');

var DatePicker = React.createClass({

    displayName: 'DatePicker',

    mixins: [DateFormatMixin],

    getInitialState: function(){

        return {
            date:null,
            today:null,
            month:null,
            open:false,
            monthOpen:false,
            yearOpen:false,
            oneDay:86400000,  // 1 day in milliseconds
        }

    },

    /**
    * Intial load so add the date to the state for use and manipulation
    **/
    componentWillMount: function(){
        this.updateState(this.props);
    },

    /**
    * Parent may have changed date propertyso lets compare and set state
    * if required
    **/
    componentWillReceiveProps: function(nextProps){
        var oDate       = this.dateToObject(nextProps.date) || new Date();
        var iDate       = oDate.setHours(0,0,0,0);
        if(this.props.date !== nextProps.date){
            this.updateState(nextProps);
        }
    },

    /**
    * Checks the prop for a date, if none found it sets it to today, also
    * sets the current month and year. Makes sure all dates are set to
    * midnight
    **/
    updateState: function(oProps){
        var oDate       = this.dateToObject(oProps.date) || new Date();
        var iDate       = oDate.setHours(0,0,0,0);
        var iMonth      = new Date(iDate).setDate(1);
        var iToday      = new Date().setHours(0,0,0,0);

        this.setState({
            date:iDate,
            today:iToday,
            month:iMonth
        });
    },

    /**
    * Toggles the state to show or hide the calendar dropdown.
    **/
    showCalendar: function() {
        if(this.state.open){
            this.hide();
        }else{
            this.show();
        }
    },

    show: function() {
    	document.addEventListener("click", this.hide);
    	this.setState({
            open:true,
            monthOpen:false,
            yearOpen:false
        });
    },

    hide: function() {
    	document.removeEventListener("click", this.hide);
    	this.setState({
            open:false,
            monthOpen:false,
            yearOpen:false
        });
    },

    /**
    * Moves the current view month forward by 1
    **/
    nextMonth: function(e){

        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();

        var oMonth  = this.dateToObject(this.state.month);
        var iMonth  = oMonth.getMonth()+1;
        var iYear   = oMonth.getFullYear();
        if(iMonth > 11){
            iMonth = 0;
            iYear++;
        }
        var oMonth = new Date(iYear,iMonth,1);
        this.setState({
            month:oMonth.getTime()
        });

    },

    /**
    * Moves the current view month back by 1
    **/
    prevMonth: function(e){

        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();

        var oMonth  = this.dateToObject(this.state.month);
        var iMonth  = oMonth.getMonth()-1;
        var iYear   = oMonth.getFullYear();
        if(iMonth < 0){
            iMonth = 11;
            iYear--;
        }
        var oMonth = new Date(iYear,iMonth,1);
        this.setState({
            month:oMonth.getTime()
        });

    },

    selectDate: function(iDate){
        if(typeof this.props.callback !== 'undefined'){
            this.props.callback(this.dateToObject(iDate));
        }
    },

    /**
    * Helper function to build all the dates for the calendar
    **/
    buildDates: function(){

        var iDate           = this.state.date;
        var iToday          = this.state.today;
        var iMonth          = this.state.month;
        var oActiveDates    = this.props.activeDates || {};

        /* Calculate first date */
        var iStartDay   = iMonth - (this.dateToObject(iMonth).getDay() * this.state.oneDay);

        var aRows = [];
        for(var iWeeks = 0; iWeeks < 6; iWeeks++){
            var aDays = [];
            //today old new active
            for(var iDays = 0; iDays < 7; iDays++){

                var aDayClass = ['day'];
                var props = {
                    key:iDays,
                    onClick:this.selectDate.bind(this,iStartDay)
                }

                if(iToday === iStartDay){
                    aDayClass.push('today');
                }

                if(iDate === iStartDay){
                    aDayClass.push('active');
                }

                // TODO: Highlight active game dates when available in the future
                if(!oActiveDates[iStartDay]){
                    // aDayClass.push('inactive');
                }

                if(this.dateToObject(iMonth).getMonth() !== this.dateToObject(iStartDay).getMonth()){
                    aDayClass.push('old');
                }

                props.className = classNames(aDayClass);
                aDays.push(
                    <td {...props}>{this.dateToObject(iStartDay).getDate()}</td>
                )

                iStartDay = iStartDay + this.state.oneDay;
            }
            aRows.push(
                <tr key={iWeeks}>{aDays}</tr>
            )
        }

        return aRows;
    },
    
    onClickToday: function(){
        this.selectDate(this.state.today);
    },

    render: function () {

        var oMonth  = this.state.month;

        var propsPicker = {
            className:"datepicker datepicker-dropdown datepicker-orient-left datepicker-orient-top",
            style:{top:'36px',left:'0px',display:'none'},
            autoFocus:true,
            tabIndex:"-1"
        }

        if(this.state.open){
            propsPicker.style.display = 'block';
        }

        var aDates = this.buildDates();

        return (
            <div className="calendar-container" data-thisdate="20150710" data-startdate="2002-10-10" ref="calendarContainer">
                <span className="datepicker date icon" onClick={this.showCalendar}></span>
                <div {...propsPicker}>
                	<div className="datepicker-days" style={{display:'block'}}>
                		<table className="table-condensed">
                			<thead>
                				<tr className="top-nav">
                					<th className="prev" style={{visibility:'visible'}} onClick={this.prevMonth}></th>
                					<th colSpan="5" className="datepicker-switch">{this.dateFormat(oMonth,'date11')}</th>
                					<th className="next" style={{visibility:'visible'}} onClick={this.nextMonth}></th>
                				</tr>
                				<tr>
                					<th className="dow">Su</th>
                					<th className="dow">Mo</th>
                					<th className="dow">Tu</th>
                					<th className="dow">We</th>
                					<th className="dow">Th</th>
                					<th className="dow">Fr</th>
                					<th className="dow">Sa</th>
                				</tr>
                			</thead>
                			<tbody>
                				{aDates}
                			</tbody>
                			<tfoot>
                				<tr>
                					<th colSpan="7" className="today" onClick={this.onClickToday} style={{display:'table-cell'}}>View Today</th>
                				</tr>
                			</tfoot>
                		</table>
                	</div>
                	<div className="datepicker-months" style={{display:'none'}}>
                		<table className="table-condensed">
                			<thead>
                				<tr className="top-nav">
                					<th className="prev" style={{visibility:'visible'}}></th>
                					<th colSpan="5" className="datepicker-switch">2015</th>
                					<th className="next" style={{visibility:'visible'}}></th>
                				</tr>
                			</thead>
                			<tbody>
                				<tr>
                					<td colSpan="7">
                					    <span className="month">Jan</span>
                					    <span className="month">Feb</span>
                					    <span className="month">Mar</span>
                					    <span className="month">Apr</span>
                					    <span className="month">May</span>
                					    <span className="month">Jun</span>
                					    <span className="month">Jul</span>
                					    <span className="month">Aug</span>
                					    <span className="month">Sep</span>
                					    <span className="month">Oct</span>
                					    <span className="month">Nov</span>
                					    <span className="month">Dec</span>
                					</td>
                				</tr>
                			</tbody>
                			<tfoot>
                				<tr>
                					<th colSpan="7" className="today" onClick={this.onClickToday} style={{display:'table-cell'}}>View Today</th>
                				</tr>
                				<tr>
                					<th colSpan="7" className="clear" style={{display:'none'}}>Clear</th>
                				</tr>
                			</tfoot>
                		</table>
                	</div>
                	<div className="datepicker-years" style={{display:'none'}}>
                		<table className="table-condensed">
                			<thead>
                				<tr className="top-nav">
                					<th className="prev" style={{visibility:'visible'}}></th>
                					<th colSpan="5" className="datepicker-switch">2009-2020</th>
                					<th className="next" style={{visibility:'visible'}}></th>
                				</tr>
                			</thead>
                			<tbody>
                				<tr>
                					<td colSpan="7">
                					    <span className="year old">2009</span>
                					    <span className="year">2010</span>
                					    <span className="year">2011</span>
                					    <span className="year">2012</span>
                					    <span className="year">2013</span>
                					    <span className="year">2014</span>
                					    <span className="year">2015</span>
                					    <span className="year">2016</span>
                					    <span className="year disabled">2017</span>
                					    <span className="year disabled">2018</span>
                					    <span className="year disabled">2019</span>
                					    <span className="year new disabled">2020</span>
                					</td>
                				</tr>
                			</tbody>
                			<tfoot>
                				<tr>
                					<th colSpan="7" className="today" onClick={this.onClickToday} style={{display:'table-cell'}}>View Today</th>
                				</tr>
                				<tr>
                					<th colSpan="7" className="clear" style={{display:'none'}}>Clear</th>
                				</tr>
                			</tfoot>
                		</table>
                	</div>
                </div>
            </div>
        )
    }

});

module.exports = DatePicker;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/common/DatePicker.jsx
 **/